
(function (angular) {
  'use strict';

  angular
    .module('bossApp.libraries', [
      'ngAnimate',
      'pascalprecht.translate',
      'ngCookies',
      'ngMaterial',
      'ui.router',
      'ui.bootstrap',
      'opinator'
    ])
    .config(configLibraries);

  angular
    .module('bossApp', [
      'bossApp.libraries',
      'bossApp.request',
      'bossApp.constants',
      'bossApp.login',
      'bossApp.olvido',
      'bossApp.bossError',
      'bossApp.adobe'
    ]);

    configLibraries.$inject = ['$mdAriaProvider'];
    function configLibraries($mdAriaProvider) {
      //$mdAriaProvider
      $mdAriaProvider.disableWarnings();
    }
})(angular);
